import axios from "axios";
import {token} from "@/service/api/token";
import {users} from "@/service/api/users";
import {live} from "@/service/api/live";
import {games} from "@/service/api/games";
import {banners} from "@/service/api/banners";
import {bonuses} from "@/service/api/bonuses";
import {store} from "@/service/api/store";
import {purchases} from "@/service/api/purchases";
import {tournaments} from "@/service/api/tournaments";
import {leagues} from "@/service/api/leagues";

export default class APIClient {

    baseUrl = () => {
        return apiAxios.defaults.baseURL;
    }

    call =  {
        token,
        users,
        live,
        games,
        banners,
        bonuses,
        store,
        purchases,
        tournaments,
        leagues
    }
}

export const api = new APIClient();
export const apiAxios= axios.create({
    baseURL: process.env.VUE_APP_API_URL
})